// @refresh skip
import { onCleanup } from "solid-js";
import { getRequestEvent, isServer } from "solid-js/web";
/**
 *
 * Read more: https://docs.solidjs.com/solid-start/reference/server/http-status-code
 */
export const HttpStatusCode = isServer
    ? (props) => {
        const event = getRequestEvent();
        event.response.status = props.code;
        event.response.statusText = props.text;
        onCleanup(() => !event.nativeEvent.handled && !event.complete && (event.response.status = 200));
        return null;
    }
    : (_props) => null;
